import React, { useEffect, useState } from "react";
import api, { formatApiError } from "../../lib/api";
import { Window, Dialog, ConfirmDialog, EmptyState, Loading } from "../../components/VB";
import RupiahInput from "../../components/RupiahInput";
import { toast } from "sonner";
import { Plus, Trash2 } from "lucide-react";

export default function Gaji() {
  const [items, setItems] = useState([]);
  const [emps, setEmps] = useState([]);
  const [loading, setLoading] = useState(true);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ employee_id: "", jenis: "Bulanan", nominal: 0, tanggal_berlaku: "", status_aktif: true });
  const [del, setDel] = useState(null);

  const load = async () => {
    setLoading(true);
    try {
      const [g, e] = await Promise.all([api.get("/gaji"), api.get("/employees")]);
      setItems(g.data); setEmps(e.data);
    } catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
    setLoading(false);
  };
  useEffect(() => { load(); }, []);

  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/gaji", { ...form, nominal: parseFloat(form.nominal) });
      toast.success("Gaji tersimpan");
      setOpen(false); load();
    } catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
  };

  const doDelete = async () => {
    try { await api.delete(`/gaji/${del.id}`); toast.success("Dihapus"); setDel(null); load(); }
    catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
  };

  const empName = (id) => emps.find((e) => e.id === id)?.nama_lengkap || "-";

  return (
    <Window
      title="Management Gaji"
      actions={<button className="vb-btn" onClick={() => setOpen(true)} data-testid="add-gaji"><Plus className="w-3 h-3 inline mr-1" />Tambah</button>}
    >
      {loading ? <Loading /> : items.length === 0 ? <EmptyState /> : (
        <table className="vb-table">
          <thead><tr><th>Karyawan</th><th>Jenis</th><th>Nominal</th><th>Tanggal Berlaku</th><th>Status</th><th>Aksi</th></tr></thead>
          <tbody>
            {items.map((it) => (
              <tr key={it.id}>
                <td>{empName(it.employee_id)}</td>
                <td>{it.jenis}</td>
                <td>Rp {it.nominal?.toLocaleString("id-ID")}</td>
                <td>{it.tanggal_berlaku}</td>
                <td>{it.status_aktif ? "Aktif" : "Nonaktif"}</td>
                <td><button className="vb-btn-danger" style={{ padding: "2px 6px" }} onClick={() => setDel(it)} data-testid={`gaji-del-${it.id}`}><Trash2 className="w-3 h-3" /></button></td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      <Dialog
        open={open} onClose={() => setOpen(false)} title="Tambah Gaji"
        footer={<><button className="vb-btn" onClick={() => setOpen(false)}>Batal</button><button className="vb-btn-primary" onClick={submit} data-testid="gaji-save">Simpan</button></>}
      >
        <form onSubmit={submit}>
          <div className="vb-form-row">
            <label className="vb-label">Karyawan*</label>
            <select className="vb-select" value={form.employee_id} onChange={(e) => setForm({ ...form, employee_id: e.target.value })} required data-testid="gaji-employee">
              <option value="">- pilih -</option>
              {emps.map((e) => <option key={e.id} value={e.id}>{e.nama_lengkap} ({e.no_karyawan})</option>)}
            </select>
          </div>
          <div className="vb-form-row">
            <label className="vb-label">Jenis Gaji*</label>
            <select className="vb-select" value={form.jenis} onChange={(e) => setForm({ ...form, jenis: e.target.value })} data-testid="gaji-jenis">
              <option>Per Jam</option><option>Harian</option><option>Bulanan</option>
            </select>
          </div>
          <div className="vb-form-row"><label className="vb-label">Nominal*</label>
            <RupiahInput value={form.nominal} onChange={(v) => setForm({ ...form, nominal: v })} required testId="gaji-nominal" /></div>
          <div className="vb-form-row"><label className="vb-label">Tanggal Berlaku*</label>
            <input type="date" className="vb-input" value={form.tanggal_berlaku} onChange={(e) => setForm({ ...form, tanggal_berlaku: e.target.value })} required data-testid="gaji-tanggal" /></div>
          <label style={{ fontSize: 13 }}><input type="checkbox" checked={form.status_aktif} onChange={(e) => setForm({ ...form, status_aktif: e.target.checked })} /> Aktif</label>
        </form>
      </Dialog>

      <ConfirmDialog open={!!del} onClose={() => setDel(null)} onConfirm={doDelete} message="Yakin hapus gaji ini?" />
    </Window>
  );
}
